import React from "react";
import { Link } from "react-router-dom";
import Headroom from "headroom.js";

import {
  UncontrolledCollapse,
  DropdownToggle,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";

const ForwardedLink = React.forwardRef((props, ref) => (
  <Link innerRef={ref} {...props} />
));

class DemoNavbar extends React.Component {
  componentDidMount() {
    let headroom = new Headroom(document.getElementById("navbar-main"));
    headroom.init();
  }
  state = {
    collapseClasses: "",
    collapseOpen: false,
  };

  onExiting = () => {
    this.setState({
      collapseClasses: "collapsing-out",
    });
  };

  onExited = () => {
    this.setState({
      collapseClasses: "",
    });
  };

  render() {
    return (
      <>
        <header className="header-global">
          <Navbar
            className="navbar-main navbar-transparent navbar-light headroom"
            expand="lg"
            id="navbar-main"
          >
            <Container>
              <NavbarBrand className="mr-lg-5" to="/" tag={Link}>
                <img alt="..." src={require("assets/img/brand/favicon.png")} />
              </NavbarBrand>
              <button className="navbar-toggler" id="navbar_global">
                <span className="navbar-toggler-icon" />
              </button>
              <UncontrolledCollapse
                toggler="#navbar_global"
                navbar
                className={this.state.collapseClasses}
                onExiting={this.onExiting}
                onExited={this.onExited}
              >
                <div className="navbar-collapse-header">
                  <Row>
                    <Col className="collapse-brand" xs="6"></Col>
                    <Col className="collapse-close" xs="6">
                      <button className="navbar-toggler" id="navbar_global">
                        <span />
                        <span />
                      </button>
                    </Col>
                  </Row>
                </div>
                <Nav className="align-items-lg-center ml-lg-auto" navbar>
                  <Nav
                    className="navbar-nav-hover align-items-lg-center"
                    navbar
                  >
                    <UncontrolledDropdown nav>
                      <DropdownToggle nav tag={Link} to="/">
                        <i className="ni ni-ui-04 d-lg-none mr-1" />
                        <span className="nav-link-inner--text">Home</span>
                      </DropdownToggle>
                    </UncontrolledDropdown>
                  </Nav>
                  <Nav
                    className="navbar-nav-hover align-items-lg-center"
                    navbar
                  >
                    <UncontrolledDropdown nav>
                      <DropdownToggle nav tag={Link} to="/about">
                        <i className="ni ni-ui-04 d-lg-none mr-1" />
                        <span className="nav-link-inner--text">About Us</span>
                      </DropdownToggle>
                    </UncontrolledDropdown>
                  </Nav>
                  <Nav
                    className="navbar-nav-hover align-items-lg-center"
                    navbar
                  >
                    <UncontrolledDropdown nav>
                      <DropdownToggle nav tag={Link} to="/contact">
                        <i className="ni ni-ui-04 d-lg-none mr-1" />
                        <span className="nav-link-inner--text">Contact Us</span>
                      </DropdownToggle>
                    </UncontrolledDropdown>
                  </Nav>
                  <Nav
                    className="navbar-nav-hover align-items-lg-center"
                    navbar
                  >
                    <UncontrolledDropdown nav>
                      <DropdownToggle nav tag={Link} to="/privacy">
                        <i className="ni ni-ui-04 d-lg-none mr-1" />
                        <span className="nav-link-inner--text">
                          Privacy Policy
                        </span>
                      </DropdownToggle>
                    </UncontrolledDropdown>
                  </Nav>
                  <Nav
                    className="navbar-nav-hover align-items-lg-center"
                    navbar
                  >
                    <UncontrolledDropdown nav>
                      <DropdownToggle nav tag={Link} to="/terms">
                        <i className="ni ni-ui-04 d-lg-none mr-1" />
                        <span className="nav-link-inner--text">
                          Terms of Service
                        </span>
                      </DropdownToggle>
                    </UncontrolledDropdown>
                  </Nav>
                </Nav>
              </UncontrolledCollapse>
            </Container>
          </Navbar>
        </header>
      </>
    );
  }
}

export default DemoNavbar;
